/* ==========================================================
   WORKLAND · Landing Combo Doble 2x1
   ========================================================== */
(function () {
  'use strict';

  function boot(root) {
    if (!root || root.dataset.wklReady === '1') return;
    root.dataset.wklReady = '1';

    var data = {};
    var dataEl = root.querySelector('[data-wkl-data]');
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    /* ---------------- Contador perenne ---------------- */
    (function countdown() {
      var box = root.querySelector('[data-wkl-clock]');
      if (!box) return;
      var hours = parseFloat(root.dataset.wklHours || '24');
      var key = 'wkl_promo_deadline_v1';
      var span = hours * 3600 * 1000;
      var end = parseInt(localStorage.getItem(key) || '0', 10);
      var now = Date.now();
      if (!end || isNaN(end) || end <= now) {
        end = now + span;
        try { localStorage.setItem(key, String(end)); } catch (e) {}
      }
      var cells = box.querySelectorAll('[data-unit]');
      function pad(n) { return n < 10 ? '0' + n : String(n); }
      function tick() {
        var left = end - Date.now();
        if (left <= 0) {
          end = Date.now() + span;
          try { localStorage.setItem(key, String(end)); } catch (e) {}
          left = span;
        }
        var s = Math.floor(left / 1000);
        var vals = {
          d: Math.floor(s / 86400),
          h: Math.floor((s % 86400) / 3600),
          m: Math.floor((s % 3600) / 60),
          s: s % 60
        };
        cells.forEach(function (c) { c.textContent = pad(vals[c.dataset.unit]); });
      }
      tick();
      setInterval(tick, 1000);
    })();

    /* ---------------- Galeria ---------------- */
    (function gallery() {
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-wkl-slide]'));
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-wkl-thumb]'));
      if (!slides.length) return;
      var i = 0;
      function go(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
        var active = thumbs[i];
        if (active && active.parentElement) {
          active.parentElement.scrollTo({ left: active.offsetLeft - 60, behavior: 'smooth' });
        }
      }
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
      var prev = root.querySelector('[data-wkl-prev]');
      var next = root.querySelector('[data-wkl-next]');
      if (prev) prev.addEventListener('click', function () { go(i - 1); });
      if (next) next.addEventListener('click', function () { go(i + 1); });

      /* swipe */
      var main = root.querySelector('[data-wkl-gal]');
      if (main) {
        var x0 = null;
        main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 44) go(dx < 0 ? i + 1 : i - 1);
          x0 = null;
        }, { passive: true });
      }
      go(0);
    })();

    /* ---------------- FAQ ---------------- */
    root.querySelectorAll('[data-wkl-faq-q]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.wkl-faq__item');
        var open = item.classList.contains('is-open');
        root.querySelectorAll('.wkl-faq__item').forEach(function (it) { it.classList.remove('is-open'); });
        if (!open) item.classList.add('is-open');
        btn.setAttribute('aria-expanded', String(!open));
      });
    });

    /* ---------------- Constructor del combo ---------------- */
    var slots = Array.prototype.slice.call(root.querySelectorAll('[data-wkl-slot]'));
    var state = slots.map(function (el) {
      return { model: el.dataset.wklDefaultModel || Object.keys(data.products)[0], size: null };
    });

    /* Cuantos pares lleva: 1 o 2. Arranca en 2 (el paquete marcado is-on) */
    var qty = 2;
    var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-wkl-tier]'));
    var preselected = tiers.filter(function (t) { return t.classList.contains('is-on'); })[0];
    if (preselected) qty = parseInt(preselected.dataset.wklTier, 10) || 2;

    function setText(sel, value) {
      if (value == null) return;
      root.querySelectorAll(sel).forEach(function (el) { el.textContent = value; });
    }

    function applyOffer() {
      var o = (data.offers || {})[String(qty)];
      if (!o) return;
      setText('[data-wkl-price-now]', '$' + o.price);
      setText('[data-wkl-price-was]', '$' + o.was);
      setText('[data-wkl-price-tag]', 'Ahorras ' + o.save + '%');
      setText('[data-wkl-cta-label]', o.cta);
      setText('[data-wkl-cta-short]', o.short);
      setText('[data-wkl-cta-sub]', o.sub);
      setText('[data-wkl-headnote]', o.note);
      setText('[data-wkl-sticky-sub]', o.stickySub);

      /* El par 2 solo existe cuando el paquete es de 2 */
      slots.forEach(function (el, i) {
        el.classList.toggle('is-hidden', i + 1 > qty);
      });
      var lbl = root.querySelector('[data-wkl-slot-label]');
      if (lbl) lbl.textContent = qty === 1 ? 'Tu par' : 'Par 1';

      tiers.forEach(function (t) {
        var on = parseInt(t.dataset.wklTier, 10) === qty;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-checked', String(on));
      });
    }

    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        qty = parseInt(t.dataset.wklTier, 10) || 2;
        applyOffer();
        sync();
      });
    });

    function renderSizes(slotEl, idx) {
      var wrap = slotEl.querySelector('[data-wkl-sizes]');
      var product = data.products[state[idx].model];
      if (!wrap || !product) return;
      wrap.innerHTML = '';
      product.variants.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'wkl-size';
        b.textContent = v.size;
        if (!v.available) {
          b.disabled = true;
          b.title = 'Agotada';
        } else {
          b.addEventListener('click', function () {
            state[idx].size = v.id;
            wrap.querySelectorAll('.wkl-size').forEach(function (x) { x.classList.remove('is-on'); });
            b.classList.add('is-on');
            sync();
          });
        }
        if (state[idx].size === v.id) b.classList.add('is-on');
        wrap.appendChild(b);
      });
    }

    slots.forEach(function (slotEl, idx) {
      slotEl.querySelectorAll('[data-wkl-model]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          state[idx].model = btn.dataset.wklModel;
          state[idx].size = null;
          slotEl.querySelectorAll('[data-wkl-model]').forEach(function (b) { b.classList.remove('is-on'); });
          btn.classList.add('is-on');
          renderSizes(slotEl, idx);
          sync();
        });
        if (btn.dataset.wklModel === state[idx].model) btn.classList.add('is-on');
      });
      renderSizes(slotEl, idx);
    });

    var ctas = Array.prototype.slice.call(root.querySelectorAll('[data-wkl-cta]'));
    var hint = root.querySelector('[data-wkl-hint]');

    /* Solo cuentan los pares que el paquete elegido incluye */
    function active() { return state.slice(0, qty); }

    function ready() { return active().every(function (s) { return !!s.size; }); }

    function sync() {
      if (hint) {
        if (ready()) {
          hint.textContent =
            qty === 1 ? 'Listo. Tu par está elegido.' : 'Listo. Tus 2 pares están elegidos.';
          hint.style.color = '#14663a';
        } else if (qty === 1) {
          hint.textContent = 'Elige tu talla para continuar.';
          hint.style.color = '#a06a00';
        } else {
          var missing = [];
          active().forEach(function (s, i) { if (!s.size) missing.push('par ' + (i + 1)); });
          hint.textContent = 'Elige la talla del ' + missing.join(' y del ') + ' para continuar.';
          hint.style.color = '#a06a00';
        }
      }
      ctas.forEach(function (c) { c.disabled = false; });
    }

    function addToCart(e) {
      e.preventDefault();
      if (!ready()) {
        var target = root.querySelector('[data-wkl-combo]');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        sync();
        if (hint) {
          hint.animate(
            [{ opacity: 1 }, { opacity: 0.25 }, { opacity: 1 }, { opacity: 0.25 }, { opacity: 1 }],
            { duration: 700 }
          );
        }
        return;
      }
      var btn = e.currentTarget;
      var label = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = 'Agregando...';

      var items = active().map(function (s) { return { id: Number(s.size), quantity: 1 }; });

      fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || 'No se pudo agregar');
          var offer = (data.offers || {})[String(qty)] || {};
          var code = offer.code;
          window.location.href = code
            ? '/discount/' + encodeURIComponent(code) + '?redirect=/checkout'
            : '/checkout';
        })
        .catch(function (err) {
          btn.disabled = false;
          btn.innerHTML = label;
          alert('No pudimos agregar tu pedido: ' + err.message + '\nIntenta con otra talla.');
        });
    }

    ctas.forEach(function (c) { c.addEventListener('click', addToCart); });
    applyOffer();
    sync();

    /* ---------------- Sticky movil ----------------
       Se muestra cuando el CTA principal ya quedo arriba de la pantalla
       y se esconde al llegar al CTA de cierre. */
    (function sticky() {
      var bar = root.querySelector('[data-wkl-sticky]');
      var anchor = root.querySelector('[data-wkl-combo]');
      var last = root.querySelector('.wkl-final');
      if (!bar || !anchor) return;
      var lastRun = 0;
      function update() {
        lastRun = Date.now();
        var passed = anchor.getBoundingClientRect().bottom < 0;
        var atEnd = last ? last.getBoundingClientRect().top < window.innerHeight : false;
        bar.classList.toggle('is-on', passed && !atEnd);
      }
      function onScroll() {
        if (Date.now() - lastRun < 80) return;
        update();
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    })();
  }

  function init() {
    document.querySelectorAll('[data-wkl-root]').forEach(boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
